import React from 'react';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var DmCustomEmbed = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(DmCustomEmbed, _React$Component);

  function DmCustomEmbed(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.refContainer = function (container) {
      _this.container = container;
    };

    return _this;
  }

  var _proto = DmCustomEmbed.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var script = document.createElement("script");
    script.src = "https://srvr.dmvs-apac.com/v2/dm-ce.min.js";
    script.async = true;
    document.body.appendChild(script);
  };

  _proto.render = function render() {
    return /*#__PURE__*/React.createElement("div", _extends({}, this.props, {
      className: "dm-player",
      ref: this.refContainer
    }));
  };

  return DmCustomEmbed;
}(React.Component);

export default DmCustomEmbed;
//# sourceMappingURL=index.modern.js.map
